import type { SVGProps } from 'react';

const SvgClickViewing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 32 32'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.482 7.942 21.509 3.93c5.4-1.8 8.333 1.147 6.546 6.547l-4.013 12.027c-2.694 8.093-7.12 8.093-9.814 0l-1.186-3.574-3.574-1.186c-8.08-2.68-8.08-7.094.014-9.8Z'
      fill='#6D91FF'
      opacity={0.4}
    />
    <path
      d='m16.164 15.505 5.08-5.093-5.08 5.093ZM16.16 16.504a.989.989 0 0 1-.706-.293 1.006 1.006 0 0 1 0-1.414l5.067-5.093a1.006 1.006 0 0 1 1.413 0 1.006 1.006 0 0 1 0 1.413l-5.067 5.094c-.2.186-.453.293-.706.293Z'
      fill='#6D91FF'
    />
  </svg>
);
export default SvgClickViewing;
